import { useEffect } from "react";
import { captureAttribution } from "@/lib/attribution";

/**
 * Global signup-attribution capture — mounts once at app root.
 * First-touch wins; records UTMs, referrer, ref/aff, and landing route to
 * localStorage so every signup path can attach them via getAttributionPayload().
 */
export default function AttributionTracker() {
  useEffect(() => {
    captureAttribution();
  }, []);
  return null;
}